module.exports = __webpack_public_path__ + "img/header-memoireRingsCheap@2x.2dc4b4f.webp";